export default __webpack_public_path__ + "static/media/ApplyFXRates.07a18bc8.png";